import { apiErrorCodes } from 'consts/api/apiErrorCodes';
import { commonTexts, settingsTexts } from 'consts/text';
import { getErrorMessageAndCode } from 'utils/errorHandlers/getErrorMessageAndCode';

export const mealTypeAddEditErrorParser = (error: unknown) => {
    const { code } = getErrorMessageAndCode(error);

    if (code === apiErrorCodes.MEAL_TYPE_NAME_TAKEN) {
        return settingsTexts.mealTypes.errorsNotifications.mealTypeNameTaken;
    }

    return commonTexts.errorMessages.unknown;
};
